var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full overflow-auto bg-gray-50 p-4",
      class: _vm.class_main,
    },
    [
      _c(
        "svg",
        {
          style: {
            width: "100%", // se adapta al ancho del modal
            maxWidth: _vm.svgWidth + "px", // pero nunca se escala más de 1:1
            height: "auto",
            maxHeight: _vm.svgHeight + "px", // opcional, evita crecer en alto
          },
          attrs: {
            width: _vm.svgWidth,
            height: _vm.svgHeight,
            viewBox: "0 0 " + _vm.svgWidth + " " + _vm.svgHeight,
          },
        },
        [
          _c(
            "g",
            _vm._l(_vm.links, function (link) {
              return _c("path", {
                key: link.id,
                attrs: {
                  d: _vm.connectorPath(link),
                  stroke: "#3E3E3E",
                  "stroke-width": "2.5",
                  fill: "none",
                },
              })
            }),
            0
          ),
          _c(
            "g",
            _vm._l(_vm.nodes, function (node) {
              return _c(
                "g",
                {
                  key: node.id,
                  attrs: {
                    transform:
                      "translate(" +
                      (node.x - _vm.nodeWidth / 2) +
                      ", " +
                      (node.y - _vm.nodeHeight / 2) +
                      ")",
                  },
                },
                [
                  _c("rect", {
                    staticClass: "shadow-sm",
                    attrs: {
                      width: _vm.nodeWidth,
                      height: _vm.nodeHeight,
                      rx: "8",
                      ry: "8",
                      fill: "#FFFFFF",
                      stroke: "#D1D5DB",
                      "stroke-width": "2",
                    },
                  }),
                  _c("rect", {
                    attrs: {
                      x: "0",
                      y: "0",
                      width: 5,
                      height: _vm.nodeHeight,
                      fill: _vm.nodeColor(node),
                      rx: "2.5",
                      ry: "2.5",
                    },
                  }),
                  _vm.nodeKind(node) === "table"
                    ? _c(
                        "g",
                        {
                          attrs: {
                            transform:
                              "translate(14, " + (_vm.nodeHeight / 2 - 9) + ")",
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                stroke: "#9CA3AF",
                                fill: "none",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            },
                            [
                              _c("ellipse", {
                                attrs: { cx: "12", cy: "5", rx: "9", ry: "3" },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M3 5v6c0 1.7 4 3 9 3s9-1.3 9-3V5",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M3 11v6c0 1.7 4 3 9 3s9-1.3 9-3v-6",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _c(
                        "foreignObject",
                        {
                          attrs: {
                            x: 14,
                            y: _vm.nodeHeight / 2 - 10,
                            width: "20",
                            height: "20",
                          },
                        },
                        [
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              style: {
                                color: "#9CA3AF",
                                fontSize: "18px",
                                lineHeight: "20px",
                              },
                              attrs: { xmlns: "http://www.w3.org/1999/xhtml" },
                            },
                            [_vm._v(" " + _vm._s(_vm.iconName(node)) + " ")]
                          ),
                        ]
                      ),
                  _c(
                    "text",
                    {
                      attrs: {
                        "font-size": "13",
                        "font-weight": "600",
                        fill: "#0F172A",
                        x: 40,
                        y: 18,
                      },
                    },
                    _vm._l(_vm.getTitleLines(node.label), function (line, idx) {
                      return _c(
                        "tspan",
                        {
                          key: "t-" + node.id + "-" + idx,
                          attrs: { x: 40, dy: idx === 0 ? 0 : 14 },
                        },
                        [_vm._v(" " + _vm._s(line) + " ")]
                      )
                    }),
                    0
                  ),
                  node.secondary
                    ? _c(
                        "text",
                        {
                          attrs: {
                            "font-size": "11",
                            fill: "#64748B",
                            x: 40,
                            y: _vm.getTitleLines(node.label).length * 14 + 30,
                          },
                        },
                        _vm._l(
                          _vm.getSecondaryLines(node.secondary),
                          function (line, idx) {
                            return _c(
                              "tspan",
                              {
                                key: "s-" + node.id + "-" + idx,
                                attrs: { x: 40, dy: idx === 0 ? 0 : 13 },
                              },
                              [_vm._v(" " + _vm._s(line) + " ")]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }